//src/Components/EmojiPicker/EmojisListContainer.tsx
import DebouncedSearch from 'Components/DebouncedSearch';
import { useCallback, useState } from 'react';
import { EmojiData, EmojiName } from '.';
import { Emojis } from './data';
import EmojisList from './EmojisList';
import searchEmojis from './SearchEmojis';

export default function EmojisListContainer() {
  const [searchResults, setSearchResults] = useState<{
    results: EmojiData[];
    search: string;
  }>({ results: [], search: '' });

  const handleSearchChange = useCallback(
    (search: string) => {
      if (search !== searchResults.search) {
        setSearchResults({ results: searchEmojis(search), search });
      }
    },
    [searchResults],
  );
  return (
    <>
      <div className="m-2">
        <DebouncedSearch onChange={handleSearchChange} />
      </div>
      <div className="mx-2">
        <div className="p-2 max-h-52 w-full overflow-y-auto">
          {searchResults.search && (
            <EmojisList
              groupName="Search Results"
              emojis={searchResults.results}
            />
          )}
          {!searchResults.search &&
            Emojis.categories.map((category) => (
              <EmojisList
                key={category.id}
                groupName={category.id}
                emojis={category.emojis.map(
                  (emojiName) => Emojis.emojis[emojiName as EmojiName],
                )}
              />
            ))}
        </div>
      </div>
    </>
  );
}
